<template>
  <BModal
    id="modal-review"
    ref="modal-review"
    centered
    :hide-header="true"
    :hide-footer="true"
    no-close-on-backdrop
  >
    <div class="flex flex-col justify-center items-center gap-12">
      <img
        :src="type === 'Suspend User'
          ? 'https://storage.googleapis.com/komerce/assets/icons/warning.svg'
          : 'https://storage.googleapis.com/komerce/assets/icons/success.svg'"
        alt="Warning"
        width="100"
        height="72"
      >
      <div class="text-black text-center">
        <div class="text-xl font-medium mb-[8px]">
          {{ type }}
        </div>
        <div class="text-base">
          Mohon verifikasi identitas kamu dengan memasukkan PIN
        </div>
      </div>
      <PincodeInput
        :key="componentKey"
        v-model="pin"
        :length="6"
        :secure="securePin"
        :disabled="disabledInputOTP"
      />
      <BButton
        type="button"
        variant="flat-primary"
        class="btn-icon"
        @click="toggleVisibilityPin"
      >
        {{ securePin ? 'Tampilkan' : 'Sembunyikan' }}
      </BButton>
    </div>
    <BRow class="flex mt-2">
      <BCol cols="6">
        <BButton
          type="button"
          variant="outline-primary"
          block
          @click="onReset"
        >
          Kembali
        </BButton>
      </BCol>
      <BCol cols="6">
        <BButton
          type="button"
          :variant="pin.length < 6 || loading ? 'secondary' : 'primary'"
          block
          :disabled="pin.length < 6 || loading"
          @click="onSubmit"
        >
          <BSpinner
            v-if="loading"
            small
            variant="light"
          />
          Konfirmasi
        </BButton>
      </BCol>
    </BRow>
  </BModal>
</template>

<script>
import { newAxiosIns } from '@/libs/axios'
import PincodeInput from 'vue-pincode-input'

export default {
  components: {
    PincodeInput,
  },
  props: {
    type: {
      type: String,
      default: null,
    },
    id: {
      type: Number,
      default: null,
    },
  },
  data() {
    return {
      pin: '',
      securePin: true,
      disabledInputOTP: false,
      componentKey: 0,
      loading: false,
    }
  },
  methods: {
    toggleVisibilityPin() {
      this.securePin = !this.securePin
      this.componentKey = Date.now()
    },
    onReset() {
      this.pin = ''
      this.securePin = true
      this.disabledInputOTP = false
      this.componentKey = Date.now()
      this.$bvModal.hide('modal-review')
    },
    async onSubmit() {
      this.loading = true
      try {
        const url = '/komcards/api/v1/risk-review'
        const action = this.type === 'Suspend User' ? 'suspend' : 'safe'
        const payload = {
          user_id: this.id,
          pin: this.pin,
          action,
        }
        await newAxiosIns.put(url, payload)
        this.onReset()
        this.$toast_success({ message: `Berhasil ${this.type}` })
        this.loading = false
        this.$emit('onRefetch')
      } catch (error) {
        const { response: { data: { meta } } } = error
        this.loading = false
        if (meta.message === 'wrong pin numbers') {
          this.$toast_error({ message: 'PIN yang kamu masukan salah!' })
          return
        }

        this.$toast_error({ message: `Gagal ${this.type}` })
      }
    },
  },
}
</script>

<style lang="scss">
[dir] input.vue-pincode-input {
    box-shadow: none!important;
    border-bottom: 2px solid black!important;
    border-radius: 0px!important;
    color: black;
}

[dir] .otp-input {
    width: 40px;
    height: 40px;
    padding: 5px;
    margin: 0 10px;
    font-size: 20px;
    border-radius: 4px;
    border: 1px solid rgba(0, 0, 0, 0.3);
    text-align: center;
  }
  [dir] .otp-input::-webkit-inner-spin-button,
  [dir] .otp-input::-webkit-outer-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }

  [dir] input.vue-pincode-input {
    box-shadow: none!important;
    border-bottom: 2px solid #FF6A3A!important;
    border-radius: 0px!important;
    color: black;
}
  [dir] input.vue-pincode-input:placeholder-shown  {
      box-shadow: none!important;
      border-bottom: 2px solid #828282!important;
      border-radius: 0px!important;
  }
  [dir] input.vue-pincode-input:focus {
    box-shadow: none!important;
    border-bottom: 2px solid #FF6A3A!important;
    border-radius: 0px!important;
}
</style>
